import { Field, Select } from '@fluentui/react-components';
import { useT } from '@powerportalspro/react';
import { AggregateDataverseChartDataSource, ChartType, QueryAggregate } from '@powerportalspro/react-charts';
import { DataverseChart } from '@powerportalspro/react-fluent';
import { useMemo, useState } from 'react';

// The contacts counted by gender, each bar stacked by age: `seriesRangeSize` splits the series
// column, the age, into a dataset for each range of years the dropdown sets, lowest first. Only the
// ranges the contacts fall in get a dataset. Contacts with no gender are a bar of their own,
// (Blank), and contacts with no age a (Blank) dataset.

const STRINGS_BASE = 'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Charts.NumberRanges.NumberRangesSeriesDemo';

// Years each dataset covers.
const RANGE_SIZES = ['10', '20', '30'];

export function NumberRangesSeriesSample() {
  const t = useT();
  const [rangeSize, setRangeSize] = useState('20');

  const source = useMemo(
    () =>
      new AggregateDataverseChartDataSource({
        tableName: 'contact',
        groupByColumn: 'gendercode',
        seriesColumn: 'ppp_age',
        seriesRangeSize: Number(rangeSize),
        aggregateColumn: 'contactid',
        aggregate: QueryAggregate.Count,
      }),
    [rangeSize],
  );

  return (
    <>
      <Field label={t(`${STRINGS_BASE}.range-size`)} orientation="horizontal">
        <Select value={rangeSize} onChange={(_, data) => setRangeSize(data.value)}>
          {RANGE_SIZES.map((size) => (
            <option key={size} value={size}>
              {t(`${STRINGS_BASE}.years`, [size])}
            </option>
          ))}
        </Select>
      </Field>
      <DataverseChart
        dataSource={source}
        type={ChartType.Bar}
        title={t(`${STRINGS_BASE}.chart-title`)}
        stacked
        height="360px"
      />
    </>
  );
}
